export default __webpack_public_path__ + "static/media/Bengali_af_1.2f83604e.mp3";